import styled, { css } from 'styled-components'
import VideoIcon from '../icons/VideoIcon'
import AudioIcon from '../icons/AudioIcon'
import TextIcon from '../icons/TextIcon'

function ResponseIcon( { type } ) {
  if ( type === 'photo' ) {
    return null
  }

  const icon = () => {
    switch ( type ) {
      case 'video': return <VideoIcon />
      case 'write': return <TextIcon />
      case 'sound': return <AudioIcon />
      default: return null
    }
  }

  return (
    <StyledResponseIcon $type={ type }>
      { icon() }
    </StyledResponseIcon>
  )
}

const StyledResponseIcon = styled.div<{ $type: string }>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  width: 64px;
  transform: translate( -50%, -50% );
  height: 64px;
  border-radius: 100%;
  background: ${ p => p.theme.colors.highlight };

  ${ p => p.$type === 'video' && css`
    > * {
      transform: translateX( 5px );
    }
  ` }
`

export default ResponseIcon
